import React from 'react';
import styled from 'styled-components';

const Table1 = () => {
    const Table = styled.div`
        text-align: left;
        border: 1px solid #004487;
        border-radius: 0;
        overflow: hidden;
        width: 100%;
        background-color: white;
    `;

    const ColType1 = styled.p`
        margin: 0;
        flex: 0 0 31%;
    `;

    const ColType2 = styled.p`
        margin: 0;
        flex: 0 0 23%;
    `;

    const ColType3 = styled.p`
        margin: 0;
        flex: 0 0 20%;
        max-width: 20%;

        @media (min-width: 768px) {
            br {
                display: none;
            }
        }
    `;

    const Tr = styled.div`
        display: flex;
        justify-content: space-between;
        padding: 10px;
    `;

    const Styledtr = styled(Tr)`
        background: #004487;
        color: white;
        font-weight: 700;
    `;

    const Trpadding = styled(Tr)`
        background: #d1d4eb;
    `;

    return (
        <Table>
            <Styledtr>
                <ColType1>Durchschnittsgewicht</ColType1>
                <ColType2>Bodenfläche je Tier im Programm (Offenfrontstall)</ColType2>
                <ColType2>Bodenfläche je Tier im Programm (Stall mit Auslauf)</ColType2>
            </Styledtr>
            <Tr>
                <ColType3>über 30 – 50 kg</ColType3>
                <ColType3>0,50 m²</ColType3>
                <ColType3>über 30 – 50 kg</ColType3>
                <ColType3>0,70 m²</ColType3>
                <ColType3>0,70 m²</ColType3>
            </Tr>
            <Trpadding>
                <ColType3>über 50 – 110 kg</ColType3>
                <ColType3>0,75 m²</ColType3>
                <ColType3>über 50 – 120 kg</ColType3>
                <ColType3>1,30 m²</ColType3>
                <ColType3>1,10 m²</ColType3>
            </Trpadding>
            <Tr>
                <ColType3>über 110 kg</ColType3>
                <ColType3>1,00 m²</ColType3>
                <ColType3>über 120 kg</ColType3>
                <ColType3>1,50 m²</ColType3>
                <ColType3>1,40 m²</ColType3>
            </Tr>
        </Table>
    );
};

export default Table1;
